import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Select, Typography } from 'antd';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields, trainingProjectAdapterTypeValues } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectAdapterTypeSelect: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Typography.Title level={5}>Adapter Type</Typography.Title>

            <Form.Item
                name={trainingProjectFormFields.adapterType}
                initialValue={
                    store.editableTrainingProject
                        ? store.editableTrainingProject.adapterType
                        : trainingProjectAdapterTypeValues.ChatAdapter
                }
            >
                <Select
                    placeholder="Select adapter type"
                    options={Object.values(trainingProjectAdapterTypeValues).map(value => ({
                        value,
                        label: value
                    }))}
                    allowClear
                />
            </Form.Item>
        </>
    );
};

export default observer(TrainingProjectAdapterTypeSelect);
